var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65119 14.43L16 8.25824C16.1483 8.19483 16.2748 8.08907 16.3637 7.95411C16.4526 7.81914 16.5 7.66093 16.5 7.49915C16.5 7.33737 16.4526 7.17915 16.3637 7.04419C16.2748 6.90922 16.1483 6.80346 16 6.74006L1.65119 0.568329C1.52695 0.513951 1.39116 0.491465 1.25609 0.502901C1.12102 0.514337 0.990916 0.559335 0.877508 0.633835C0.764099 0.708335 0.670959 0.809994 0.606489 0.929639C0.542019 1.04928 0.508248 1.18315 0.508223 1.31917L0.5 5.12287C0.5 5.53542 0.804244 5.89021 1.21538 5.93971L12.8342 7.49915L1.21538 9.05033C0.804244 9.10809 0.5 9.46288 0.5 9.87543L0.508223 13.6791C0.508223 14.2649 1.10849 14.6692 1.65119 14.43Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.61a06f566fded551a07bd2f6412bf9ae.svg";
export { ForwardRef as ReactComponent };